import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	12: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 6.00002,
				cy: 5.99999,
				r: 4.25625,
				stroke: "#63AAED",
				strokeWidth: .9375
			}), /* @__PURE__ */ n("path", {
				d: "M5.99998 3.60001C6.47465 3.60001 6.93867 3.74076 7.33334 4.00448C7.72802 4.26819 8.03564 4.64302 8.21729 5.08157C8.39894 5.52011 8.44647 6.00267 8.35386 6.46822C8.26126 6.93378 8.03268 7.36142 7.69703 7.69706C7.36139 8.03271 6.93375 8.26129 6.46819 8.35389C6.00264 8.4465 5.52008 8.39897 5.08154 8.21732C4.64299 8.03567 4.26816 7.72805 4.00445 7.33337C3.74073 6.9387 3.59998 6.47468 3.59998 6.00001L5.99998 6.00001V3.60001Z",
				fill: "#63AAED"
			})]
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 8.00001,
				cy: 8.00001,
				r: 5.675,
				stroke: "#63AAED",
				strokeWidth: 1.25
			}), /* @__PURE__ */ n("path", {
				d: "M7.99999 4.79999C8.63289 4.79999 9.25157 4.98766 9.77781 5.33929C10.304 5.69091 10.7142 6.19068 10.9564 6.7754C11.1986 7.36012 11.262 8.00354 11.1385 8.62428C11.015 9.24502 10.7103 9.8152 10.2627 10.2627C9.8152 10.7103 9.24502 11.015 8.62428 11.1385C8.00354 11.262 7.36012 11.1986 6.7754 10.9564C6.19068 10.7142 5.69091 10.304 5.33928 9.77781C4.98766 9.25157 4.79999 8.63289 4.79999 7.99999L7.99999 7.99999L7.99999 4.79999Z",
				fill: "#63AAED"
			})]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 10,
				cy: 10,
				r: 7.09375,
				stroke: "#63AAED",
				strokeWidth: 1.5625
			}), /* @__PURE__ */ n("path", {
				d: "M10 6C10.7911 6 11.5645 6.2346 12.2223 6.67412C12.8801 7.11365 13.3928 7.73836 13.6955 8.46927C13.9983 9.20017 14.0775 10.0044 13.9231 10.7804C13.7688 11.5563 13.3878 12.269 12.8284 12.8284C12.269 13.3878 11.5563 13.7688 10.7804 13.9231C10.0044 14.0775 9.20017 13.9983 8.46927 13.6955C7.73836 13.3928 7.11365 12.8801 6.67412 12.2223C6.2346 11.5645 6 10.7911 6 10L10 10L10 6Z",
				fill: "#63AAED"
			})]
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 12,
				cy: 12,
				r: 8.5125,
				stroke: "#63AAED",
				strokeWidth: 1.875
			}), /* @__PURE__ */ n("path", {
				d: "M12 7.20001C12.9494 7.20001 13.8774 7.48153 14.6667 8.00896C15.4561 8.53639 16.0713 9.28605 16.4346 10.1631C16.7979 11.0402 16.893 12.0053 16.7078 12.9364C16.5226 13.8676 16.0654 14.7228 15.3941 15.3941C14.7228 16.0654 13.8676 16.5226 12.9364 16.7078C12.0053 16.893 11.0402 16.7979 10.1631 16.4346C9.28605 16.0713 8.53639 15.4561 8.00896 14.6667C7.48153 13.8774 7.20001 12.9494 7.20001 12L12 12V7.20001Z",
				fill: "#63AAED"
			})]
		}),
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as StatusInReviewIcon };
